export default (sku) => {
  let skuColor = ""
  switch (sku.toUpperCase()) {
    case "SS":
      skuColor = "Sterling Silver"
      break
    case "KW":
    case "10KW":
    case "14KW":
    case "18KW":
      skuColor = "White Gold"
      break
    case "KY":
    case "10KY":
    case "14KY":
    case "18KY":
      skuColor = "Yellow Gold"
      break
    case "KR":
    case "10KR":
    case "14KR":
    case "18KR":
      skuColor = "Rose Gold"
      break
    case "10KT":
    case "14KT":
      skuColor = "Tri-color Gold"
      break
    case "SSKYP":
    case "SS18KYP":
    case "VERMY":
      skuColor = "Gold Plated Silver"
      break
    case "SST18KYP":
      skuColor = "Gold Plated Stainless Steel"
      break
  }
  return skuColor
}

export const mapMetalClass = (sku, bg = true) => {
  const metal = sku.replace(/[0-9]/g, "").toLowerCase()
  switch (metal) {
    case "ss":
    case "sst":
    case "sstkyp":
    case "tss":
    case "vermy":
    case "sskyp":
      return bg ? "bg-sku-ss" : "text-sku-ss"
    case "kw":
    case "trw":
      return bg ? "bg-sku-kw" : "text-sku-kw"
    case "ky":
    case "tky":
      return bg ? "bg-sku-ky" : "text-sku-ky"
    case "kr":
    case "tkr":
      return bg ? "bg-sku-kr" : "text-sku-kr"
    case "tung":
      return bg ? "bg-sku-tung" : "text-sku-tung"
    case "cob":
      return bg ? "bg-sku-cob" : "text-sku-cob"
    default:
      return bg ? "bg-sku-cer" : "text-sku-cer"
  }
}
